var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropXLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 186,
    viewBox: "0 0 631 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.154 140.019H47.5849C20.3128 139.913 0 124.32 0 95.3314C0 53.802 32.2026 30.8268 67.6672 30.8268C82.4631 30.8268 93.9941 35.2532 103.567 46.2139V46.2153L86.5968 60.7592C80.9401 54.4343 72.6726 51.4848 64.1876 51.4848C42.2106 51.4848 22.8472 67.5042 22.8472 91.5347C22.8472 109.243 35.2485 118.941 51.5673 118.941C60.7051 118.941 70.497 116.2 78.7645 109.243L91.3833 123.788C77.5455 135.101 63.4902 139.958 48.154 140.019Z",
    fill: "#2D547D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.606 32.8613L147.518 46.5593C157.958 33.2828 170.576 30.5441 182.104 30.5441C192.544 30.5441 201.896 34.126 206.899 39.3941L193.414 58.3617C188.629 54.146 183.843 52.0396 175.577 52.0396C160.134 52.0396 144.907 61.3112 141.428 80.4881L131.204 136.754H108.8L127.724 32.8613H148.606",
    fill: "#2D547D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.441 76.7799C317.441 111.349 289.156 139.387 251.079 139.387C221.706 139.387 204.517 120.205 204.517 94.4883C204.517 59.7052 233.02 31.2469 270.661 31.2469C299.817 31.2469 317.441 50.8524 317.441 76.7799M227.363 91.3238C227.363 106.714 234.325 119.151 254.779 119.151C278.276 119.151 294.595 100.601 294.595 79.9402C294.595 64.3424 286.109 51.2739 266.963 51.2739C243.899 51.2739 227.363 70.4564 227.363 91.3238",
    fill: "#2D547D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.245 185.454H316.419V184.492L316.245 185.454Z",
    fill: "#2D547D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.232 80.6682V80.6772C447.843 113.83 421.36 139.381 384.963 139.381C371.873 139.381 355.948 134.731 350.277 121.838L338.714 185.454H316.419V184.492L343.952 32.8605H365.11L363.365 49.7677C372.321 39.1434 385.262 32.9694 397.69 31.2468C400.095 30.9146 402.479 30.7471 404.813 30.7471C407.355 30.7666 409.813 30.9355 412.174 31.2468C434.445 34.181 448.521 49.7383 450.232 71.2688V71.2769C450.339 72.6479 450.398 74.0439 450.405 75.4621V76.0902C450.398 77.6311 450.339 79.158 450.232 80.6682ZM358.413 90.6914C358.413 70.0348 375.167 52.3264 398.664 52.3264C416.506 52.3264 427.386 63.4992 427.386 79.7307C427.386 102.076 408.672 118.518 386.7 118.518C369.291 118.518 358.413 106.503 358.413 90.6914Z",
    fill: "#2D547D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M443.59 136.713H471.72L518.58 83.3265L493.838 32.906L463.661 32.9066L489.907 83.7629L443.59 136.713Z",
    fill: "#2D547D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M524.341 78.1023L514.165 57.9855L534.604 32.906H564.278L524.341 78.1023Z",
    fill: "#009CE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M523.171 90.7415L545.631 136.713H517.407L504.45 111.794L523.171 90.7415Z",
    fill: "#7E665D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M630.065 3.84057C619.966 33.9502 612.573 37.1566 574.823 28.8342C581.578 -0.478372 590.263 -4.54323 630.065 3.84057Z",
    fill: "#A6C579"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropXLogo);
export default __webpack_public_path__ + "static/media/CropX_logo.f87296a5d656489561032220a9c5e5d0.svg";
export { ForwardRef as ReactComponent };